function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Edit } from 'lucide-react';
import { Trash2 } from 'lucide-react';
import { Shield } from 'lucide-react';
import { useAuth } from '@edusense/shared-auth-core';
import { DropdownMenu, DropdownMenuItem } from '@edusense/shared-ui-kit';
import { SocialHeader } from '@edusense/shared-ui-layout';
import { ContentBaseSimple as ContentBase } from '@edusense/shared-ui-content';
import { SocialActions } from '@edusense/features-social-actions';
import { combineRefs } from '../utils';
// 스타일 컴포넌트 불러오기
import { PostContainer, HoverBackground, PostWrapper, ContentContainer, ContentWrapper } from '../styles/socialpost.styles';
/**
 * 표준 모드의 소셜 포스트 컴포넌트
 */ var SocialPostStandard = function(param) {
    var id = param.id, displayPost = param.displayPost, _param_isDetailView = param.isDetailView, isDetailView = _param_isDetailView === void 0 ? false : _param_isDetailView, _param_dataSource = param.dataSource, dataSource = _param_dataSource === void 0 ? 'default' : _param_dataSource, likeState = param.likeState, repostState = param.repostState, _param_isRetweet = param.isRetweet, isRetweet = _param_isRetweet === void 0 ? false : _param_isRetweet, retweetAuthor = param.retweetAuthor, replyToUser = param.replyToUser, _param_showThreadLineTop = param.showThreadLineTop, showThreadLineTop = _param_showThreadLineTop === void 0 ? false : _param_showThreadLineTop, _param_showThreadLineBottom = param.showThreadLineBottom, showThreadLineBottom = _param_showThreadLineBottom === void 0 ? false : _param_showThreadLineBottom, _param_displayStyle = param.displayStyle, displayStyle = _param_displayStyle === void 0 ? 'default' : _param_displayStyle, _param_showActions = param.showActions, showActions = _param_showActions === void 0 ? true : _param_showActions, _param_likesCount = param.likesCount, likesCount = _param_likesCount === void 0 ? 0 : _param_likesCount, _param_repostsCount = param.repostsCount, repostsCount = _param_repostsCount === void 0 ? 0 : _param_repostsCount, _param_repliesCount = param.repliesCount, repliesCount = _param_repliesCount === void 0 ? 0 : _param_repliesCount, _param_viewsCount = param.viewsCount, viewsCount = _param_viewsCount === void 0 ? 0 : _param_viewsCount, linkPreview = param.linkPreview, quotedContent = param.quotedContent, postRef = param.postRef, viewTrackerRef = param.viewTrackerRef, handleDeleteTweet = param.handleDeleteTweet, handleReportTweet = param.handleReportTweet, handleEditTweet = param.handleEditTweet, handleLike = param.handleLike, handleRepost = param.handleRepost, handleQuote = param.handleQuote, handleComment = param.handleComment, clickHandler = param.clickHandler, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    var _displayPost_poll;
    // 현재 로그인한 사용자 정보
    var user = useAuth().user;
    // 작성자가 현재 로그인한 사용자인지 확인
    var isCurrentUserPost = user && displayPost.author && user.username === displayPost.author.username;
    // 스레드 라인이 있는지 확인
    var hasThreadLine = showThreadLineTop || showThreadLineBottom;
    // 기존 postRef와 viewTrackerRef 병합
    var setRefs = function(element) {
        combineRefs(element, postRef, viewTrackerRef);
    };
    // 커스텀 액션 메뉴 렌더링
    var renderCustomActionMenu = function() {
        return /*#__PURE__*/ React.createElement(DropdownMenu, {
            isOpen: true,
            onClose: function() {},
            position: "bottom",
            align: "end"
        }, isCurrentUserPost ? // 자신의 포스트인 경우 편집 및 삭제 옵션
        /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DropdownMenuItem, {
            icon: /*#__PURE__*/ React.createElement(Edit, {
                className: "h-4 w-4"
            }),
            onClick: handleEditTweet,
            "data-testid": "edit-tweet-button"
        }, "편집하기"), /*#__PURE__*/ React.createElement(DropdownMenuItem, {
            icon: /*#__PURE__*/ React.createElement(Trash2, {
                className: "h-4 w-4"
            }),
            onClick: function() {
                return handleDeleteTweet(id);
            },
            variant: "danger",
            "data-testid": "delete-tweet-button"
        }, "삭제하기")) : // 다른 사용자의 포스트인 경우 신고 옵션
        /*#__PURE__*/ React.createElement(DropdownMenuItem, {
            icon: /*#__PURE__*/ React.createElement(Shield, {
                className: "h-4 w-4"
            }),
            onClick: function() {
                return handleReportTweet(id);
            },
            variant: "danger",
            "data-testid": "report-tweet-button"
        }, "신고하기"));
    };
    return /*#__PURE__*/ React.createElement(PostContainer, {
        $isDetailView: isDetailView,
        $isQuoted: dataSource === 'quoted',
        onClick: clickHandler,
        className: className
    }, /*#__PURE__*/ React.createElement(HoverBackground, null), /*#__PURE__*/ React.createElement(PostWrapper, {
        ref: setRefs,
        "data-thread-container": true,
        "data-post-id": id
    }, /*#__PURE__*/ React.createElement(SocialHeader, {
        author: displayPost.author,
        createdAt: _instanceof(displayPost.createdAt, Date) ? displayPost.createdAt : new Date(displayPost.createdAt),
        showTimestamp: true,
        showActions: true,
        variant: "tweet",
        isRetweet: isRetweet,
        retweetAuthor: retweetAuthor,
        tweetId: id,
        size: displayStyle === 'compact' ? 'sm' : 'md',
        replyToUser: replyToUser,
        showThreadLineTop: showThreadLineTop,
        showThreadLineBottom: showThreadLineBottom,
        customRenderActionMenu: renderCustomActionMenu
    }), /*#__PURE__*/ React.createElement(ContentContainer, {
        $hasThreadLine: hasThreadLine
    }, /*#__PURE__*/ React.createElement(ContentWrapper, {
        onClick: function(e) {
            var _e_target;
            // Poll 컴포넌트 클릭은 전파하지 않음
            var isPollClick = (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.closest('.poll-container, .poll-component');
            if (isPollClick) {
                console.log('Poll 컴포넌트 클릭 감지, 이벤트 전파 중지');
                e.stopPropagation();
                return;
            }
            // 이벤트가 처리되지 않은 경우, clickHandler 호출하여 포스트 페이지로 이동
            if (clickHandler && !isDetailView && dataSource !== 'quoted') {
                clickHandler();
            }
        }
    }, /*#__PURE__*/ React.createElement(ContentBase, {
        content: displayPost.content,
        images: displayPost.images,
        videos: displayPost.videos,
        linkPreview: linkPreview,
        quotedContent: quotedContent ? _object_spread_props(_object_spread({}, quotedContent), {
            author: _object_spread_props(_object_spread({}, quotedContent.author), {
                profileImage: quotedContent.author.profileImage || ''
            })
        }) : undefined,
        poll: displayPost.poll,
        onVote: (_displayPost_poll = displayPost.poll) === null || _displayPost_poll === void 0 ? void 0 : _displayPost_poll.onVote
    })), showActions && /*#__PURE__*/ React.createElement(SocialActions, {
        id: id,
        likesCount: likesCount,
        retweetsCount: repostsCount,
        repliesCount: repliesCount,
        viewsCount: viewsCount,
        isLiked: likeState,
        isRetweetedByMe: repostState,
        size: displayStyle === 'compact' ? 'sm' : 'md',
        onLike: handleLike,
        onRetweet: function() {
            return handleRepost(id);
        },
        onQuote: function(id, content) {
            return handleQuote(id, content);
        },
        onComment: function() {
            return handleComment(id);
        }
    }))));
};
export default SocialPostStandard;
